import React from 'react';
import { connect } from 'react-redux';
import { htmlEncode, getFullname } from '../../../../utils/commonFunctions';
const mapStateToProps = (state) => {
	return {
		testData: state.rootReducer.testPageDetails,
		unitName: state.rootReducer.myCourse?.unitName,
		isRetail: state.rootReducer.loginDetails?.isRetail,
	};
};

const ImageElement = ({
	imagesrc,
	liveClassURL,
	unitName,
	queDesc,
	isRetail,
	testData: { isClose, elementDescription, element_name, elementId },
}) => {
	let btnName = 'live-button';
	if (isClose === 1) {
		queDesc = 'You can view a recording of this LIVE class here.';
		btnName = 'btn btn-success';
	}

	return (
		<span>
			{!!imagesrc && <img src={imagesrc} alt="" className="img-responsive" />}
			<p className="questionDesc" dangerouslySetInnerHTML={{ __html: queDesc }} />

			{!!liveClassURL && (
				<div className="text-center">
					<span className="liveTime">{elementDescription}</span>
					<a
						href={
							liveClassURL +
							'?mid=lceid-' +
							elementId +
							'23ftrgr&mname=' +
							htmlEncode(element_name) +
							'&uname=' +
							htmlEncode(getFullname()) +
							'&courseId=' +
							htmlEncode(localStorage.getItem('active_course_id')) +
							'&is_retail=' +
							htmlEncode(isRetail) +
							'&unitname=' +
							htmlEncode(unitName)
						}
						target="_blank"
						rel="noopener noreferrer"
						className={btnName}
					>
						{isClose === 1
							? 'Click here to view the recording'
							: 'Click here to join the Live Class'}
					</a>
				</div>
			)}
		</span>
	);
};
export default connect(mapStateToProps)(ImageElement);
